module.exports = __webpack_public_path__ + "static/media/fl.35c359e7.svg";